<app-page-header [header]="pageTitle" backgroundPath="assets/images/lead/lead-privilege.jpg"></app-page-header>


<div class="container" style="padding-top: 30px;">
    <section class="section-select -menu d-block d-lg-none">
        <app-dropdown [title]="pageTitle" [valueDropdown]="valueDropdown" (selected)="selectValue($event)">
        </app-dropdown>
    </section>

    <ul class="nav nav-tabs tab-four show-on-max" id="myTab" role="tablist">

        <li class="nav-item">
            <a class="nav-link {{choiceFromSelect==='promo'? 'active': ''}}" id="two-tab" data-toggle="tab"
                [routerLink]="['/Promotion','promo']" role="tab" aria-controls="two" aria-selected="false" href="#two"
                (click)="selectValue(1)">
                {{language.promotiontab1}}
            </a>
        </li>
        <li class="nav-item">
            <a class="nav-link {{choiceFromSelect==='non-promo'? 'active': ''}}" id="three-tab" data-toggle="tab"
                [routerLink]="['/Promotion','non-promo']" role="tab" aria-controls="three" aria-selected="false"
                href="#three" (click)="selectValue(2)">
                {{language.promotiontab2}}
            </a>
        </li>
    </ul>

    <div class="tab-content" id="myTabContent">
        <div [ngSwitch]="choiceFromSelect">
            <div *ngSwitchCase="'promo'" class="tab-pane fade show active" id="one" role="tabpanel"
                aria-labelledby="one-tab" style="padding-top: 30px">

                <section class="show-listing -highlight">
                    <div *ngIf="flag == 'th'; else elseEnhighlight">
                        <div class="row">
                            <div *ngFor="let item of highlightpromotion" class="col-ss-12 col-xs-4 col-sm-4">
                                <section class="card -new ">
                                    <div class="thumb view">
                                        <a [routerLink]="['/th/Promotion/detail',item.promotionid]" class="parent">
                                            <span *ngIf="item.promotion_img_Thum != ''" class="img-photo img-fluid"
                                                [style.background-image]="getBackground(item.promotion_img_Thum)"></span>
                                        </a>
                                    </div>
                                    <div class="info">
                                        <h3 #dot class="h6 topic-title insert-dotdotdot"
                                            style="overflow-wrap: break-word;">
                                            <a
                                                [routerLink]="['/th/Promotion/detail',item.promotionid]">{{ item.title }}</a>
                                        </h3>
                                        <time>{{ date_thai(item.publicDate) }}</time>
                                    </div>
                                </section>
                            </div>
                        </div>
                    </div>
                    <ng-template #elseEnhighlight>
                        <div class="row">
                            <div *ngFor="let item of highlightpromotion" class="col-ss-12 col-xs-4 col-sm-4">
                                <section class="card -new ">
                                    <div class="thumb view">
                                        <a [routerLink]="['/th/Promotion/detail',item.promotionid]" class="parent">
                                            <span *ngIf="item.promotion_img_Thum_en != ''" class="img-photo img-fluid"
                                                [style.background-image]="getBackground(item.promotion_img_Thum_en)"></span>
                                        </a>
                                    </div>
                                    <div class="info">
                                        <h3 #dot class="h6 topic-title insert-dotdotdot"
                                            style="overflow-wrap: break-word;">
                                            <a
                                                [routerLink]="['/th/Promotion/detail',item.promotionid]">{{ item.title_en }}</a>
                                        </h3>
                                        <time>{{item.publicDate | date:'dd MMMM yyyy'}}</time>
                                    </div>
                                </section>
                            </div>
                        </div>
                    </ng-template>
                </section>

                <section class="show-listing">
                    <div *ngIf="flag == 'th'; else elseEnpromotion">
                        <div class="row">
                            <div *ngFor="let item of renderpromotion" class="col-ss-12 col-xs-6 col-lg-4">
                                <section id="newsList-2" class="card -new" *ngIf="item.promotion_img_Thum != ''">
                                    <div class="thumb-2 view">
                                        <a [routerLink]="['/th/Promotion/detail',item.promotionid]" class="parent">
                                            <span *ngIf="item.promotion_img_Thum != ''" class="img-photo img-fluid"
                                                [style.background-image]="getBackground(item.promotion_img_Thum)"></span>
                                        </a>

                                    </div>
                                    <div class="info" style=" padding-left: 10px; padding-top: 0px;">
                                        <h3 #dot class="h6 topic-title insert-dotdotdot"
                                            style="overflow-wrap: break-word;">
                                            <a
                                                [routerLink]="['/th/Promotion/detail',item.promotionid]">{{item.title}}</a>
                                        </h3>
                                        <time>{{ date_thai(item.publicDate) }} </time>
                                    </div>
                                </section>
                            </div>
                        </div>
                    </div>
                    <ng-template #elseEnpromotion>
                        <div class="row">
                            <div *ngFor="let item of renderpromotion" class="col-ss-12 col-xs-6 col-lg-4">
                                <section id="newsList-2" class="card -new" *ngIf="item.promotion_img_Thum_en != ''">
                                    <div class="thumb-2 view">
                                        <a [routerLink]="['/th/Promotion/detail',item.promotionid]" class="parent">
                                            <span *ngIf="item.promotion_img_Thum_en != ''" class="img-photo img-fluid"
                                                [style.background-image]="getBackground(item.promotion_img_Thum_en)"></span>
                                        </a>

                                    </div>
                                    <div class="info" style=" padding-left: 10px; padding-top: 0px;">
                                        <h3 #dot class="h6 topic-title insert-dotdotdot"
                                            style="overflow-wrap: break-word;">
                                            <a
                                                [routerLink]="['/th/Promotion/detail',item.promotionid]">{{item.title_en}}</a>
                                        </h3>
                                        <time>{{item.publicDate | date:'dd MMMM yyyy'}} </time>
                                    </div>
                                </section>
                            </div>
                        </div>

                    </ng-template>
                </section>
                <footer class="text-center" style="padding-top: 40px">
                    <app-paginator [currentPage]="promotionCurrentPage" [totalPage]="totalpromotionPage"
                        (currentPageNumber)="setCurrentpromotionPage($event)"></app-paginator>
                </footer>
            </div>


            <div *ngSwitchCase="'non-promo'" class="tab-pane fade show active" id="one" role="tabpanel"
                aria-labelledby="one-tab" style="padding-top: 30px">

                <section class="show-listing -highlight">
                    <div *ngIf="flag == 'th'; else elsehighlightbenefit">
                        <div class="row">
                            <div *ngFor="let item of highlightbenefit" class="col-ss-12 col-xs-4 col-sm-4">
                                <section class="card -new ">
                                        <div class="thumb view">
                                            <a [routerLink]="['/th/Benefit/detail',item.benefitid]" class="parent">
                                                <span *ngIf="item.benefit_img_Thum != ''" class="img-photo img-fluid"
                                                    [style.background-image]="getBackground(item.benefit_img_Thum)"></span>
                                            </a>
                                        </div>
                                        <div class="info">
                                            <h3 #dot class="h6 topic-title insert-dotdotdot"
                                                style="overflow-wrap: break-word;">
                                                <a [routerLink]="['/th/Benefit/detail',item.benefitid]">{{item.title}}</a>
                                            </h3>
                                            <time>{{ date_thai(item.publicDate) }}</time>
                                        </div>
                                </section>
                            </div>
                        </div>
                    </div>
                    <ng-template #elsehighlightbenefit>
                        <div class="row">
                            <div *ngFor="let item of highlightbenefit" class="col-ss-12 col-xs-4 col-sm-4">
                                <section class="card -new ">
                                        <div class="thumb view">
                                            <a [routerLink]="['/th/Benefit/detail',item.benefitid]" class="parent">
                                                <span *ngIf="item.benefit_img_Thum_en != ''" class="img-photo img-fluid"
                                                    [style.background-image]="getBackground(item.benefit_img_Thum_en)"></span>
                                            </a>
                                        </div>
                                        <div class="info">
                                            <h3 #dot class="h6 topic-title insert-dotdotdot"
                                                style="overflow-wrap: break-word;">
                                                <a [routerLink]="['/th/Benefit/detail',item.benefitid]">{{item.title_en}}</a>
                                            </h3>
                                            <time>{{item.publicDate | date:'dd MMMM yyyy' }}</time>
                                        </div>
                                </section>
                            </div>
                        </div>
                    </ng-template>
                </section>

                <section class="show-listing">
                    <div class="row">
                        <div *ngFor="let item of renderbenefit" class="col-ss-12 col-xs-6 col-lg-4">
                            <div *ngIf="flag == 'th'; else elserenderbenefit">
                                <section id="newsList-2" class="card -new" *ngIf="item.benefit_img_Thum != ''">
                                    <div class=" thumb-2 view">
                                        <a [routerLink]="['/th/Benefit/detail',item.benefitid]" class="parent">
                                            <span *ngIf="item.benefit_img_Thum != ''" class="img-photo img-fluid"
                                                [style.background-image]="getBackground(item.benefit_img_Thum)"></span>
                                        </a>
                                    </div>
                                    <div class="info" style=" padding-left: 10px; padding-top: 0px;">
                                        <h3 #dot class="h6 topic-title insert-dotdotdot"
                                            style="overflow-wrap: break-word;">
                                            <a [routerLink]="['/th/Benefit/detail',item.benefitid]">{{item.title}}</a>
                                        </h3>
                                        <time>{{ date_thai(item.publicDate) }} </time>
                                    </div>
                                </section>
                            </div>
                            <ng-template #elserenderbenefit>
                                <section id="newsList-2" class="card -new" *ngIf="item.benefit_img_Thum_en != ''">
                                    <div class=" thumb-2 view">
                                        <a [routerLink]="['/th/Benefit/detail',item.benefitid]" class="parent">
                                            <span *ngIf="item.benefit_img_Thum_en != ''" class="img-photo img-fluid"
                                                [style.background-image]="getBackground(item.benefit_img_Thum_en)"></span>
                                        </a>
                                    </div>
                                    <div class="info" style=" padding-left: 10px; padding-top: 0px;">
                                        <h3 #dot class="h6 topic-title insert-dotdotdot"
                                            style="overflow-wrap: break-word;">
                                            <a
                                                [routerLink]="['/th/Benefit/detail',item.benefitid]">{{item.title_en}}</a>
                                        </h3>
                                        <time>{{item.publicDate | date:'dd MMMM yyyy'}} </time>
                                    </div>
                                </section>
                            </ng-template>
                        </div>
                    </div>
                </section>
                <footer class="text-center" style="padding-top: 40px">
                    <app-paginator [currentPage]="benefitCurrentPage" [totalPage]="totalbenefitPage"
                        (currentPageNumber)="setCurrentbenefitPage($event)"></app-paginator>
                </footer>
            </div>
        </div>
    </div>
</div>